<template>
  <div class="option mb-3 select-primary rounded px-3 py-3 flex align-start" :class="checked ? 'selected-color' : ''" @click="$emit('click',index)">
    <span class="mr-2">{{ index }}</span>
    <span>{{label}}</span>
  </div>
</template>

<script>
export default {
  name: "QuestionOption",
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    index: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {

    };
  }
}
</script>

<style lang="scss" scoped>
.option {
  width: 420px;
  height: 54px;
  background-color: #f1f3f8;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #2e323c;
  display: flex;
  align-items: center;
  padding: 0 15px;
  margin: 0 auto 15px;
  border: 1px solid #f1f3f8;
  &.selected-color {
    background-color: rgba(225, 63, 55, 0.15);
    border: 1px solid #e13f37;
    color: #e13f37;
  }
}
.select-primary {
  background-color: rgba(0, 199, 176, 0.05);
}
.selected-color {
  background-color: #00c7b0;
}
.selected-color .text-color-white {
  color: #fff;
}
.mr-2 {
  margin-right: 20px;
}
</style>
